import { 
  getAuthMethod, 
  postAuthMethod, 
  putAuthMethod, 
  deleteAuthMethod,
  formDataPostService
} from "./HttpServices";
import { audienceApiUrl, importApiUrl } from "../constant/Constant";

export const getAudiences = (params) => {
  const queryString = params ? new URLSearchParams(params).toString() : "";
  const url = queryString ? `${audienceApiUrl}?${queryString}` : audienceApiUrl;
  return getAuthMethod(url);
};

export const getAudienceById = (id) => {
  return getAuthMethod(`${audienceApiUrl}/${id}`);
};

export const getAudienceMembers = (id, params) => {
  const queryString = params ? new URLSearchParams(params).toString() : "";
  const url = queryString ? `${audienceApiUrl}/${id}/members?${queryString}` : `${audienceApiUrl}/${id}/members`;
  return getAuthMethod(url);
};

export const updateAudienceMember = (audienceId, memberId, data) => {
  return putAuthMethod(`${audienceApiUrl}/${audienceId}/members`, memberId, data);
};

export const removeAudienceMember = (audienceId, memberId) => {
  return deleteAuthMethod(`${audienceApiUrl}/${audienceId}/members/${memberId}`);
};

export const bulkRemoveAudienceMembers = (audienceId, memberIds) => {
  return postAuthMethod(`${audienceApiUrl}/${audienceId}/members/bulk-delete`, memberIds);
};

export const createAudience = (data) => {
  return postAuthMethod(audienceApiUrl, data);
};

export const updateAudience = (id, data) => {
  return putAuthMethod(audienceApiUrl, id, data);
};

export const deleteAudience = (id) => {
  return deleteAuthMethod(`${audienceApiUrl}/${id}`);
};

// Import APIs
export const manualImport = (audienceId, members) => {
  return postAuthMethod(`${audienceApiUrl}/${audienceId}/import/manual`, members);
};

export const uploadCsvForPreview = (audienceId, file, columnMapping) => {
  const formData = new FormData();
  formData.append("file", file);
  
  // Send the mapping as a single JSON string parameter
  formData.append("columnMapping", JSON.stringify(columnMapping));

  // Because formDataPostService handles multipart implicitly via axios
  return formDataPostService(`${audienceApiUrl}/${audienceId}/import/csv`, formData);
};

export const confirmImportJob = (jobId, allowDuplicates = false) => {
  return postAuthMethod(`${importApiUrl}/${jobId}/confirm?allowDuplicates=${allowDuplicates}`);
};

export const importGoogleContacts = (audienceId) => {
  return postAuthMethod(`${audienceApiUrl}/${audienceId}/import/google`);
};

export const importMicrosoftContacts = (audienceId) => {
  return postAuthMethod(`${audienceApiUrl}/${audienceId}/import/microsoft`);
};

export const getImportPreview = (jobId, params) => {
  const queryString = params ? new URLSearchParams(params).toString() : "";
  const url = queryString ? `${importApiUrl}/${jobId}/preview?${queryString}` : `${importApiUrl}/${jobId}/preview`;
  return getAuthMethod(url);
};

export const getAudienceImports = (audienceId, params) => {
  const queryString = params ? new URLSearchParams(params).toString() : "";
  const url = queryString ? `${audienceApiUrl}/${audienceId}/imports?${queryString}` : `${audienceApiUrl}/${audienceId}/imports`;
  return getAuthMethod(url);
};

export const getInvalidContactsForJob = (jobId, params) => {
  const queryString = params ? new URLSearchParams(params).toString() : "";
  const url = queryString ? `${importApiUrl}/${jobId}/invalid-contacts?${queryString}` : `${importApiUrl}/${jobId}/invalid-contacts`;
  return getAuthMethod(url);
};
